import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Button, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';

import { PhoneInput } from '../../common';
import { addMemberToLoyaltyProgram, editEntityField } from '../../../actions';

class MemberEditor extends Component {

    handleSubmit = (event) => {
        this.props.addMemberToLoyaltyProgram(this.props.loyaltyProgramId, this.props.entity);
        event.preventDefault();
    }

    render() {
        const { entity } = this.props;

        if (!this.props.entity) {
            return null;
        }

        const member = entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <PhoneInput
                        value={member.phone}
                        onChange={(phone) => this.props.editEntityField('phone', phone)}
                    />
                </Form.Field>

                <Form.Group>
                    <Button type='submit' primary floated="right">
                        {i18next.t('save')}
                    </Button>
                </Form.Group>

            </Form>
        );
    }
}

MemberEditor.propTypes = {
    loyaltyProgramId: PropTypes.any,
    addMemberToLoyaltyProgram: PropTypes.func,
    editEntityField: PropTypes.func,
    entity: PropTypes.object
    
};

const mapStateToProps = (state) => {
    const { entity } = state.editor;

    return { entity };
};

export default connect(mapStateToProps, { addMemberToLoyaltyProgram, editEntityField })(MemberEditor);
